<template lang="pug" functional>
  .mobile-skeleton
    v-card.mb-3(
      v-for="i in props.count"
      :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top
            .list-mobile__title-skeleton
          .list-mobile__content
            .list-mobile__item(v-for="j in 5" :key="`${i}-${j}`")
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
</template>

<script>
export default {
  name: 'PlanningTableSkeletonMobile',

  props: {
    count: {
      type: Number,
      default: 5
    }
  }
}
</script>
